import React from "react";
import classNames from "classnames";

export function CollapsibleList({ className = "", children }) {
    return (
        <div className={classNames("component-collapsible-list", className)}>
            {children}
        </div>
    );
}

